import React from "react";
import styles from "./formPicker.module.scss";
import { DatePicker, Form } from "antd";

const { RangePicker } = DatePicker;

const getSafeShowTime = showTime => {
  if (typeof showTime === "boolean") {
    return showTime ? { format: "h:mm A", use12Hours: true, minuteStep: 5, second: false } : false;
  }
  return {
    format: "h:mm A",
    use12Hours: true,
    minuteStep: 5,
    second: false,
    ...showTime
  };
};

const AppDatePicker = props => {
  const {
    containerClassname = "",
    pickerClassname = "",
    containerProps = {},
    pickerProps = {},
    errors,
    touched,
    value,
    onChange,
    showTime,
    size = "large",
    name,
    placeholder = "Select Time",
    rangeSelector = false,
    secondary = false,
    disabledDate
  } = props;

  let finalClassNames = styles.formPickerPrimary;
  if (secondary) {
    finalClassNames = styles.formPickerSecondary;
  }

  const effectiveShowTime = getSafeShowTime(showTime ?? pickerProps.showTime);
  const finalPickerProps = {
    ...pickerProps,
    showTime: effectiveShowTime,
    format: pickerProps.format ?? "YYYY-MM-DD h:mm A"
  };
  return (
    <Form.Item className={`${finalClassNames} ${containerClassname}`} validateStatus={errors && touched ? "error" : ""} help={errors && touched ? errors : ""} {...containerProps}>
      {rangeSelector ? (
        <RangePicker
          showTime={showTime}
          placeholder={placeholder}
          onChange={onChange}
          name={name}
          size={size}
          value={value}
          className={pickerClassname}
          disabledDate={disabledDate}
          {...finalPickerProps}
        />
      ) : (
        <DatePicker
          showTime={showTime}
          placeholder={placeholder}
          onChange={onChange}
          name={name}
          value={value}
          size={size}
          className={pickerClassname}
          disabledDate={disabledDate}
          {...finalPickerProps}
        />
      )}
    </Form.Item>
  );
};

export default AppDatePicker;
